import replaceApiIri from 'helpers/replaceApiIri';
import { TagType } from 'store/tagTypes';
import { ProjectMember } from './interfaces';

const argsContainsProjectMember = (
  arg: undefined | ProjectMember,
): arg is ProjectMember => arg !== undefined && !!arg.project;

interface InvalidatedTags {
  type: TagType;
  id: string | number;
}

export default function handleInvalidateTags(
  args: ProjectMember | undefined,
): InvalidatedTags[] {
  return argsContainsProjectMember(args)
    ? [
        { type: 'Projects', id: 'LIST' },
        {
          type: 'Projects',
          id: +replaceApiIri(args.project, 'projects'),
        },
      ]
    : [{ type: 'Projects', id: 'LIST' }];
}
